import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as get } from './configurations/get';
import { apiAction as getDashboardContent } from './configurations/getDashboardContent';
import { apiAction as getDashboardEvent } from './configurations/getDashboardEvent';
import { apiAction as getRecommended } from './configurations/getRecommended';
import { apiAction as loadMore } from './configurations/loadMore';

export const apiActions = {
  searchTile: {
    get,
    getRecommended,
    getDashboardContent,
    getDashboardEvent,
    loadMore
  }
}

const actions = mapActionsFromConfigurations('searchTile')(configurations);

export * from './configurations/endpoints';

export default actions;


// WEBPACK FOOTER //
// ./src/state/modules/search-tile/actions.js